import { useIonModal } from '@ionic/react';
import { FullComment } from 'model';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useDeleteCommentMutation } from '../api/CommentApi';
import { Confirmation } from '../pages/Confirmation';
import { setCommentView } from '../state/commentViewSlice';
import { IconButton } from './IconButton';
import { PostContentsToHTML } from './PostContentsToHTML';
import { IconTrash } from './QuirkIcons';
import { TruncatedSummary } from './TruncatedSummary';
import { useCurrentUser } from '../hooks/useCurrentUser.js';

interface deleteCommentType {
	comment: FullComment;
	action?: () => void;
	label?: string;
}
export const DeleteComment: React.FC<deleteCommentType> = ({ comment, action, label }) => {
	const user = useCurrentUser();
	const dispatch = useDispatch();
	const [deleteComment, { isError, isLoading, isSuccess }] = useDeleteCommentMutation();
	const isAuthor = user._id === comment.author;
	useEffect(() => {
		dispatch(
			setCommentView({
				id: String(comment._id),
				isLoading,
				isSuccess,
				isError
			})
		);
	}, [comment._id, dispatch, isError, isLoading, isSuccess]);

	const onDelete = async () => {
		dismiss();
		await deleteComment(comment._id);
		action && action();
	};

	const removeTooltip = async (dismiss: () => void) => {
		await dismiss();
		action && action();
	};
	const [present, dismiss] = useIonModal(Confirmation, {
		onDismiss: () => removeTooltip(dismiss),
		action: onDelete,
		actionLabel: 'Delete',
		dismissLabel: 'Cancel',
		content: (
			<>
				<h4 style={{ marginBottom: '40px' }}>
					Are you sure you want to delete {`${isAuthor ? 'your' : 'this'}`} comment?
				</h4>
				<TruncatedSummary>
					<PostContentsToHTML>{comment.comment}</PostContentsToHTML>
				</TruncatedSummary>
			</>
		)
	});

	const setsetCommentView = () => {
		present();
	};

	return <IconButton label={label || 'Delete'} icon={<IconTrash />} onClick={setsetCommentView} />;
};
